import { motion } from "framer-motion";

export function LogoMark({ size = 44, className = "", animate = false }) {
  const carAnim = animate
    ? { initial: { opacity: 0, y: 4, scale: 0.9 }, animate: { opacity: 1, y: 0, scale: 1 }, transition: { duration: 0.6, delay: 0.3, ease: [0.22, 1, 0.36, 1] } }
    : {};
  const lineAnim = animate
    ? { initial: { pathLength: 0, opacity: 0 }, animate: { pathLength: 1, opacity: 1 }, transition: { duration: 0.7, delay: 0.6, ease: "easeInOut" } }
    : {};
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className}>
      <defs>
        <linearGradient id="okaStroke" x1="0" y1="0" x2="48" y2="48">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="100%" stopColor="#8ea2c8" />
        </linearGradient>
      </defs>

      {/* Badge */}
      <motion.rect
        x="3" y="3" width="42" height="42" rx="13"
        stroke="url(#okaStroke)" strokeWidth="1.4" fill="none"
        {...(animate ? { initial: { opacity: 0, scale: 0.82 }, animate: { opacity: 1, scale: 1 }, transition: { duration: 0.55 } } : {})}
      />

      <motion.g {...carAnim}>
        {/* Car body */}
        <path
          d="M10 29.4 C10 27.7 10.9 26.9 12.2 26.5 L16 25.1 L19.8 20.5 C20.9 19.2 22.2 18.7 23.8 18.7 L27.9 18.7 C29.5 18.7 30.8 19.3 31.9 20.6 L34.9 24.1 L37.5 25 C38.9 25.5 39.7 26.5 39.7 28 L39.7 29.6 L10 29.6 Z"
          fill="#ffffff"
        />
        {/* Windows */}
        <path d="M20.4 20.5 L23.3 20.5 L23.3 23.9 L17.6 23.9 Z" fill="#0B132B" />
        <path d="M24.5 20.5 L27.7 20.5 C28.7 20.5 29.4 20.9 30.1 21.7 L31.9 23.9 L24.5 23.9 Z" fill="#0B132B" />
        {/* Belt-line accent */}
        <path d="M17.2 24 L34 24" stroke="#8ea2c8" strokeWidth="0.9" strokeLinecap="round" />
        {/* Wheels */}
        <circle cx="16.6" cy="29.9" r="3.2" fill="#ffffff" />
        <circle cx="16.6" cy="29.9" r="1.5" fill="#0B132B" />
        <circle cx="33" cy="29.9" r="3.2" fill="#ffffff" />
        <circle cx="33" cy="29.9" r="1.5" fill="#0B132B" />
      </motion.g>

      {/* Road line */}
      <motion.path
        d="M11 33.6 L37 33.6"
        stroke="#8ea2c8" strokeWidth="1.4" strokeLinecap="round"
        {...lineAnim}
      />
    </svg>
  );
}

export default function Logo({ onClick, compact = false }) {
  return (
    <button onClick={onClick} data-testid="nav-logo" className="group flex items-center gap-3">
      <motion.span
        whileHover={{ rotate: -6, scale: 1.05 }}
        transition={{ type: "spring", stiffness: 300, damping: 15 }}
        className="relative flex items-center justify-center"
      >
        <span className="absolute inset-0 bg-white/10 blur-md rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <LogoMark size={compact ? 38 : 44} />
      </motion.span>
      <span className="flex flex-col items-start leading-none">
        <span className="flex items-baseline gap-1.5">
          <span className="font-display text-white text-2xl tracking-tight">OKA</span>
          <span className="text-[10px] font-semibold tracking-[0.3em] text-[#0B132B] bg-white px-1.5 py-0.5">VTC</span>
        </span>
        <span className="mt-1 text-[8px] tracking-[0.35em] uppercase text-white/50">Chauffeur privé · Lyon</span>
      </span>
    </button>
  );
}
